module.exports = __webpack_public_path__ + "img/nucleus3.d2c90375.png";